module.exports = __webpack_public_path__ + "media/npc_dota_hero_snapfire.ecd4bc12.webm";